const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const downloadQuotation = async (rfq, quotation, token) => {
  try {
    // Fetch PDF from backend
    const response = await fetch(`${BACKEND_URL}/api/quotation/${quotation.id}/pdf`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to generate quotation PDF');
    }
    
    // Get the blob from response
    const blob = await response.blob();
    
    // Create download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Quotation_${quotation.id.substring(0, 8)}_${rfq.company_name.replace(/\s+/g, '_')}.pdf`;
    
    // Trigger download
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('Error downloading quotation:', error);
    throw error;
  }
};

// Legacy text-based quotation generator (kept for reference)
export const generateQuotationDocument = (rfq, quotation) => {
  const quotationDate = new Date(quotation.sent_at).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  
  const validUntil = new Date(quotation.sent_at);
  validUntil.setDate(validUntil.getDate() + quotation.validity_days);
  const validUntilDate = validUntil.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  const content = `
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
                    SIMPSON & MUNRO (INDIA) PVT LTD
              POWER TRANSMISSION BELTS & INDUSTRIAL SOLUTIONS
                          Established 1951
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

                          PRICE QUOTATION
                          
Quotation No: ${quotation.id.substring(0, 8).toUpperCase()}
Date: ${quotationDate}
Valid Until: ${validUntilDate}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

CUSTOMER INFORMATION
────────────────────────────────────────────────────────────────────
Company Name:     ${rfq.company_name}
Contact Person:   ${rfq.contact_person}
Email:           ${rfq.email}
Phone:           ${rfq.phone}
${rfq.gst_number ? `GST Number:      ${rfq.gst_number}` : ''}
Delivery Address: ${rfq.delivery_location}
Required By:      ${rfq.required_delivery_date}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

PRODUCT SPECIFICATIONS
────────────────────────────────────────────────────────────────────
Belt Type:           ${rfq.configuration.belt_type}
Dimensions:          ${rfq.configuration.thickness}mm (T) × ${rfq.configuration.width}mm (W) × ${rfq.configuration.length}mm (L)
Number of Plies:     ${rfq.configuration.number_of_plies}
Colour:             ${rfq.configuration.colour}
Surface Type:        ${rfq.configuration.surface_type}
Temperature Range:   ${rfq.configuration.temperature_range}
Oil/Chemical Resist: ${rfq.configuration.oil_chemical_resistance ? 'Yes' : 'No'}
Quantity Ordered:    ${rfq.configuration.quantity} units

${rfq.additional_remarks ? `
Special Requirements:
${rfq.additional_remarks}
` : ''}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

PRICING
────────────────────────────────────────────────────────────────────
Unit Price:          ₹${quotation.unit_price.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} per unit
Quantity:            ${rfq.configuration.quantity} units
                     ─────────────────────────────────────────────
Subtotal:           ₹${(quotation.unit_price * rfq.configuration.quantity).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

GST @ 18%:          ₹${((quotation.unit_price * rfq.configuration.quantity) * 0.18).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                     ─────────────────────────────────────────────
TOTAL AMOUNT:       ₹${quotation.quoted_price.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                     ═════════════════════════════════════════════

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Generated on: ${new Date().toLocaleString('en-IN')}
Quotation ID: ${quotation.id}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
`;

  return content;
};
